// audioStore.ts

const audioMap = new Map<string, HTMLAudioElement>()

export function setAudioEl(id: string, el: HTMLAudioElement) {
  audioMap.set(id, el)
}

export function getAudioEl(id: string): HTMLAudioElement | undefined {
  return audioMap.get(id)
}
